module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.3627/img/app-marketplace-network-1x.png"